import React from 'react';
import { COLORS } from "Constants/BIDashboardConstants"

const ZoomOutIcon = () => {
  return (
    <svg width="15px" height="2px" viewBox="0 0 15 2" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Image-Button-Row" transform="translate(-502.000000, -19.000000)" fill={COLORS.oneGp.globalBlue} fillRule="nonzero">
          <g id="Image-Nav" transform="translate(350.000000, 0.000000)">
            <path d="M166.6875,19 L152.3125,19 C152.139844,19 152,19.1398438 152,19.3125 L152,20.5625 C152,20.7351562 152.139844,20.875 152.3125,20.875 L166.6875,20.875 C166.860156,20.875 167,20.7351562 167,20.5625 L167,19.3125 C167,19.1398438 166.860156,19 166.6875,19 Z" id="Path" />
          </g>
        </g>
      </g>
    </svg>
  );
};

export default ZoomOutIcon;
